import { baseBitcoinYayURL, baseWSURL, baseAcademyUrl, baseLottoUrl, baseShopURL, baseCEXURL } from "../../services/api";
import React, { useContext, useEffect, useRef, useState } from "react";
// import greetingCard from "../../assets/header-icons/sec_header_greeting.svg";
import logo from "../../assets/header-icons/indexx-logo-v3-dark.svg";
// ZodiacDashboardLink is still exported by the launcher; the Dashboard itself
// is out of scope for now, so no header renders it.
import ZodiacLauncher from "../ZodiacLauncher/ZodiacLauncher";
// @ts-ignore — zodiacAuth.js is plain JS, synced from zodiac-embed, no types
import { notifySignedOut } from "../ZodiacLauncher/zodiacAuth";
import "./style.css";
import CrossIcon from "../../assets/header-icons/cross";
import CrossIconNew from "../../assets/homepage/updated/cross_white.png";
import DarkMode from "../DarkMode/DarkMode";
import { Theme } from "../../utils/themeContext";
import frame from "../../assets/updated/header/captain.png";
import beeframe from "../../assets/updated/header/normal.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import dummy from "../../assets/updated/dummy.png";
// import Fantasy_Lotto from '../../assets/BSheader/fantasy.png';
// import token from '../../assets/BSheader/tokens icon 1.svg';
// import token_white from '../../assets/BSheader/tokens icon  white (1).svg';
import Data, { auth_header_data, updateAuthHeaderData } from "./data";
import { useMediaQuery } from "@mui/material";
import {
  getCaptainBeeStatics,
  getHoneyUserDetails,
  getCaptainBeeByEmail,
  checkByemail,
  logoutAPI,
} from "../../services/api";
const EXTERNAL_DOMAINS = [
  baseBitcoinYayURL,
  "https://eenymeenyminymoe.io",
  "https://aiainai.ai",
  baseWSURL,
  baseLottoUrl,
  baseCEXURL,
  baseAcademyUrl,
  baseShopURL,
  "https://whoisbitcoinsatoshi.wtf",
];

/*
 * The legacy session keys, read fresh.
 *
 * Module level so the listener below depends on nothing: these four keys are
 * the only session this header has ever known, and "zodiac:session" is the
 * signal that they just changed underneath it.
 */
const readLegacySession = () => ({
  accessToken: localStorage.getItem("access_token"),
  email: localStorage.getItem("user") || localStorage.getItem("email") || "",
});

const getSignedUrl = (url: string): string => {
  const accessToken = localStorage.getItem("access_token");
  const shortToken = localStorage.getItem("shortToken");
  if (!accessToken || !shortToken) return url;
  if (!EXTERNAL_DOMAINS.some((d) => url.startsWith(d))) return url;
  const urlObj = new URL(url);
  urlObj.searchParams.set("signInToken", shortToken);
  return urlObj.toString();
};

const HeaderTest: React.FC = () => {
  const { pathname } = useLocation();
  const themeData = useContext(Theme);
  const timeoutRef = useRef<any>(null);
  const elementRef = useRef(null);
  const [headerData, setHeaderData] = useState(Data);
  const [authHeader, setAuthHeader] = useState(auth_header_data);
  const [backdropVisibility, setBackdropVisibility] = useState(false);
  const [theme, setTheme] = useState<any>(themeData?.theme ?? "dark");
  const [activeIndex, setactiveIndex] = useState(0);
  const isMobile = useMediaQuery("(max-width:1310px)");
  /*
   * State, not a read during render.
   *
   * This header decided with a bare `localStorage.getItem("access_token")`,
   * which is the answer from BEFORE the launcher's silent session check has
   * run — a network round trip that finishes after first paint. Nothing told
   * it to look again, so the bar said "Login" against a live session until
   * zodiacAuth's fallback reloaded the whole page. Listening for the event it
   * dispatches first means re-reading in place instead.
   */
  const [legacySession, setLegacySession] = useState(readLegacySession);
  const isAuthenticated = legacySession.accessToken !== null;

  const [isCaptain, setisCaptain] = useState(false);
  const [loading, setLoading] = useState(true);

  const [userProfile, setUserProfile] = useState();
  const [profileLoading, setProfileLoading] = useState(true);
  const userEmail = legacySession.email;

  const navigate = useNavigate();
  useEffect(() => {
    if (themeData?.theme) {
      setTheme(themeData?.theme);
    }
  }, [themeData?.theme]);

  useEffect(() => {
    const onEstateSession = () => setLegacySession(readLegacySession());
    window.addEventListener("zodiac:session", onEstateSession);
    return () => window.removeEventListener("zodiac:session", onEstateSession);
  }, []);

  // useEffect(() => {
  //   updateAuthHeaderData(authHeader).then((data) => console.log(data));
  // }, [isAuthenticated]);

  useEffect(() => {
    setAuthHeader(
      authHeader.map((el) => {
        if (pathname.includes("/how-master-login-works")) {
          if (el.mainTextDesktop === "How it Works") {
            return { ...el, active: true };
          }
        } else if (pathname.includes("/auth/login")) {
          if (el.mainTextDesktop === "Login") {
            return { ...el, active: true };
          }
        } else if (pathname.includes("/auth/signup-email")) {
          if (el.mainTextDesktop === "Register") {
            return { ...el, active: true };
          }
        }
        // In all other cases, set 'active' to false
        return { ...el, active: false };
      })
    );
  }, [pathname]);

  const handleExternalLink = (
    e: React.MouseEvent<HTMLAnchorElement>,
    href: string
  ) => {
    const signed = getSignedUrl(href);
    if (signed !== href) {
      e.preventDefault();
      window.location.href = signed;
    }
  };

  const handleItemClick = (path: string, i: number) => {
    setactiveIndex(i);
    window.location.href = getSignedUrl(path);
  };
  const handleMouseEnter = () => {
    // Set a timeout to open the dropdown after 0.2s
    timeoutRef.current = setTimeout(() => {
      setBackdropVisibility(true);
    }, 200);
  };

  const handleMouseLeave = () => {
    // Clear the timeout if user leaves before 0.2s
    clearTimeout(timeoutRef.current);
    // Hide the dropdown after a delay
    setTimeout(() => {
      setBackdropVisibility(false);
    }, 200);
  };
  const updateBackDropVisibility = (type: string) => {
    if (type === "enter") handleMouseEnter();
    if (type === "leave") handleMouseLeave();
  };

  useEffect(() => {
    const element = elementRef.current;

    if (element) {
      const computedStyle = window.getComputedStyle(element);
      const visibility = computedStyle.getPropertyValue("visibility");
      const display = computedStyle.getPropertyValue("display");

      if (visibility === "hidden" || display === "none") {
        console.log("Element is hidden or not visible");
      } else {
        console.log("Element is visible");
        setBackdropVisibility(false);
      }
    }
  }, []);

  useEffect(() => {
    /*
     * Last writer must be the LATEST run, not the fastest one.
     *
     * This effect now re-runs when the email arrives (see the dependency
     * below), so a cold load starts it twice: once anonymously, then again once
     * Zodiac signs the user in. Both races to setisCaptain/setUserProfile, and
     * the anonymous pass has the shorter call chain, so without this guard it
     * usually resolves LAST and overwrites the real answer with the signed-out
     * one. A page reload used to hide that by cutting the first run off; it no
     * longer happens on this route.
     *
     * Cheaper than an AbortController and enough here: the requests are
     * harmless to complete, only their results must be discarded.
     */
    let cancelled = false;

    async function checkUserType() {
      let userType =
        localStorage.getItem("userType") !== undefined
          ? String(localStorage.getItem("userType"))
          : undefined;
      let username =
        localStorage.getItem("username") !== undefined
          ? String(localStorage.getItem("username"))
          : undefined;

      const user =
        localStorage.getItem("user") !== undefined
          ? String(localStorage.getItem("user"))
          : undefined;
      let getUserType = await checkByemail(String(user));
      userType = getUserType.userType;
      const accessToken =
        localStorage.getItem("access_token") !== undefined
          ? String(localStorage.getItem("access_token"))
          : undefined;
      // debugger;
      if (cancelled) return;

      if (userType === "CaptainBee") {
        if (accessToken && accessToken !== "null" && accessToken !== "") {
          //debugger;
          let resObj = await getCaptainBeeByEmail(String(user));
          console.log("resObj", resObj);
          username = resObj?.data.Username;
        }
        if (cancelled) return;
        setisCaptain(true);
        setLoading(false);
        if (username) {
          getCaptainBeeStatics(String(username)).then((data: any) => {
            if (cancelled) return;
            setUserProfile(data?.data?.affiliateUserProfile?.photoIdFileurl);
            setProfileLoading(false);
          });
        }
      } else {
        setisCaptain(false);
        setLoading(false);
        getHoneyUserDetails(String(user)).then((data: any) => {
          if (cancelled) return;
          setUserProfile(data?.data?._doc?.profilePic);
          setProfileLoading(false);
        });
      }
    }
    checkUserType();
    /*
     * Keyed on the email, because on a cold visit this first runs with none —
     * checkByemail(String(null)) — and the avatar and CaptainBee flag it sets
     * would otherwise keep that anonymous answer once the session lands. The
     * body re-reads storage itself; the dependency is only the signal that
     * there is now something different to read.
     */
    return () => {
      cancelled = true;
    };
  }, [userEmail]);

  const logOutUser = async (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    const userType =
      localStorage.getItem("userType") !== undefined
        ? String(localStorage.getItem("userType"))
        : undefined;
    await logoutAPI();
    localStorage.removeItem("user"); //remove one item
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("email");
    localStorage.clear(); //clear all localstorage
    console.log(userType);

    /*
     * And now end the session at the PROVIDER, which nothing above does.
     *
     * Everything up to here empties this browser and tells Indexx ID nothing.
     * The IdP session row and its first-party cookie survive, so the next page
     * load's prompt=none check finds them and signs the person straight back
     * in — click Logout on test.indexx.ai, go back to "/", and it greets you
     * by name again. On a shared machine the next person inherits the session
     * across every product. notifySignedOut revokes the refresh family and
     * navigates to /session/end, which is what actually ends it.
     *
     * The localStorage.clear() above does not disarm it: the OIDC tokens live
     * in sessionStorage (zodiacAuth.js storeGet/storeSet), so the refresh
     * token is still there to be revoked.
     *
     * Called LAST, because it NAVIGATES and may not come back. It resolves
     * false — never throws — when no launcher client has been built on this
     * page; only then is there a local redirect left to make, and the legacy
     * one below then runs exactly as it always did.
     *
     * When it does navigate, the provider returns the browser to this origin's
     * root rather than /auth/login: only "/" is registered in this client's
     * post_logout_redirect_uris (identity/src/config.js:107), and endSession
     * matches that list exactly. Asking for /auth/login would strand the user
     * on the provider's own confirmation page instead of bringing them back.
     */
    const ended = await notifySignedOut().catch(() => false);
    if (ended) return;

    if (userType === "CaptainBee") {
      window.location.href = "/auth/login";
    } else if (userType === "HoneyBee") {
      window.location.href = "/auth/login";
    } else {
      if (window.location.pathname.includes("trade-to-earn"))
        window.location.reload();
      else window.location.href = "/auth/login";
    }
  };

  const handleLogout = (e: any, nm: string) => {
    if (nm !== "logout") return;
    logOutUser(e);
  };

  return (
    <>
      <nav style={{ position: "fixed", top: 0, left: 0, zIndex: 10000 }}>
        <div className="wrapper">
          {isMobile ? (
            ""
          ) : (
            <div
              className="backdrop"
              style={{
                display: "block",
                opacity: backdropVisibility ? 1 : 0,
                background: theme === "dark" ? "rgba(0,0,0,0.5)" : "",
                transitionDelay: ".1s",
                height: backdropVisibility ? "100vh" : 0,
              }}
            ></div>
          )}

          <div
            style={{
              display: "flex",
              alignItems: "center",

              flex: 1,
            }}
          >
            <div className="logo" style={{ marginRight: "30px" }}>
              <a href="/">
                <img
                  src={logo}
                  alt="indexx ai logo"
                  style={{ marginTop: "-8px" }}
                />
              </a>
            </div>
            <input type="radio" name="slider" id="menu-btn" />
            <input type="radio" name="slider" id="close-btn" />
            <ul
              className="nav-links"
              style={{
                flex: 1,
              }}
            >
              <label htmlFor="close-btn" className="btn close-btn">
                <img src={CrossIconNew} alt="indexx ai cross icon" />
              </label>
              {isMobile &&
                authHeader
                  .filter((el) => el.isAuth === isAuthenticated)
                  .map((element, i) => (
                    <>
                      {element.mainTextDesktop === "Logout" ||
                      element.mainTextMob === "Logout" ? (
                        <li
                          className="main"
                          style={{
                            // marginLeft: i === 0 ? "auto" : "",
                            cursor: "pointer",
                          }}
                          // onClick={(e) =>
                          //   handleLogout(
                          //     e,
                          //     element.mainTextDesktop.toLocaleLowerCase()
                          //   )
                          // }
                        >
                          <button onClick={(e) => handleLogout(e, "logout")}>
                            Logout
                          </button>
                        </li>
                      ) : (
                        <li
                          className="main"
                          style={
                            {
                              // marginLeft: i === 0 ? "auto" : "",
                            }
                          }
                        >
                          <a
                            href={element.href}
                            onClick={(e) => handleExternalLink(e, element.href)}
                            className={`desktop-item ${
                              element.active ? "link_active" : ""
                            }`}
                          >
                            {isAuthenticated
                              ? userEmail
                              : element.mainTextDesktop}
                          </a>
                          <input type="checkbox" id={element.mainTextDesktop} />
                          {isAuthenticated ? (
                            <label
                              htmlFor={element.mainTextMob}
                              className="mobile-item"
                            >
                              {isAuthenticated
                                ? userEmail
                                : element.mainTextDesktop}
                              {element.hasMegaDrop ? " >" : ""}
                            </label>
                          ) : (
                            <a href={element.href} onClick={(e) => handleExternalLink(e, element.href)} className="mobile-item">
                              {isAuthenticated
                                ? userEmail
                                : element.mainTextDesktop}
                              {element.hasMegaDrop}
                            </a>
                          )}

                          {element.hasMegaDrop ? (
                            <div
                              className="mega-box"
                              style={{
                                background:
                                  theme?.palette?.mode === "light"
                                    ? "#FAFAFC"
                                    : "",
                                color:
                                  theme?.palette?.mode === "light"
                                    ? "#333336 !important"
                                    : "",
                              }}
                              ref={elementRef}
                            >
                              <div className="content">
                                {element.dropDownContent.map((elem: any) => (
                                  <div
                                    className="row"
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <header>{elem?.heading}</header>
                                    <ul
                                      className={`mega-links ${
                                        elem?.mainList ? "main" : ""
                                      }`}
                                    >
                                      {elem?.links.map((el: any) => (
                                        <li>
                                          <a
                                            onClick={(e) => {
                                              handleLogout(e, el.name.toLocaleLowerCase());
                                              handleExternalLink(e, el.href);
                                            }}
                                            href={el.href}
                                            className={
                                              theme?.palette?.mode === "light"
                                                ? "dark_color"
                                                : ""
                                            }
                                          >
                                            {el.name}
                                          </a>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                ))}

                                <div className="row"></div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </li>
                      )}
                    </>
                  ))}
              {headerData.map((element) => (
                <>
                  <li
                    className="main"
                    onMouseEnter={() =>
                      updateBackDropVisibility(
                        !element.hasMegaDrop ? "" : "enter"
                      )
                    }
                    onMouseLeave={() =>
                      updateBackDropVisibility(
                        !element.hasMegaDrop ? "" : "leave"
                      )
                    }
                  >
                    <a
                      href={element.href}
                      onClick={(e) => handleExternalLink(e, element.href)}
                      className={`desktop-item ${
                        element.active ? "link_active" : ""
                      }`}
                      onMouseEnter={() =>
                        updateBackDropVisibility(
                          !element.hasMegaDrop ? "" : "enter"
                        )
                      }
                    >
                      {element.mainTextDesktop}
                    </a>
                    {element.hasMegaDrop ? (
                      <>
                        <input type="checkbox" id={element.mainTextMob} />

                        <label
                          htmlFor={element.mainTextMob}
                          className="mobile-item"
                        >
                          {element.mainTextDesktop}{" "}
                          {element.hasMegaDrop ? ">" : ""}
                        </label>
                      </>
                    ) : (
                      <a href={element.href} onClick={(e) => handleExternalLink(e, element.href)} className="mobile-item">
                        {element.mainTextMob}
                      </a>
                    )}

                    {element.hasMegaDrop ? (
                      <div
                        className="mega-box"
                        ref={elementRef}
                        style={{
                          background: theme === "light" ? "#FAFAFC" : "",
                          color: theme === "light" ? "#333336 !important" : "",
                        }}
                      >
                        <div className="content">
                          {element.dropDownContent.map((elem) => (
                            <div
                              className="row"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <header
                                style={{
                                  color:
                                    theme === "light"
                                      ? "#A0A0A5 !important"
                                      : "",
                                }}
                              >
                                {elem.heading}
                              </header>
                              <ul
                                className={`mega-links ${
                                  elem.mainList ? "main" : ""
                                }`}
                              >
                                {elem.links.map((el) => (
                                  <li
                                    className="profile-list-item"
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      textAlign: "left",
                                    }}
                                  >
                                    <a
                                      href={el.href}
                                      onClick={(e) => handleExternalLink(e, el.href)}
                                      className={
                                        theme === "light" ? "dark_color" : ""
                                      }
                                    >
                                      {el.name}
                                    </a>
                                    <div
                                      className={`profile-inner-item-border-bottom `}
                                      style={{
                                        background: "#11BE6A",
                                        width: "16px",
                                        height: "3px",
                                        marginTop: "-5px",
                                      }}
                                    ></div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ))}

                          <div className="row"></div>
                          <div className="row"></div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </li>
                </>
              ))}

              {!isMobile &&
                authHeader
                  .filter((el) => el.isAuth === isAuthenticated)
                  .map((element, i) => (
                    <>
                      {element.mainTextDesktop === "Logout" ||
                      element.mainTextMob === "Logout" ? (
                        <li
                          className="main"
                          style={{
                            // First item of this list owns the margin-left:auto
                            // that pushes the cluster right. Only the first —
                            // two autos in one flex row split the free space.
                            marginLeft: i === 0 ? "auto" : "",
                            display: "flex",
                            cursor: "pointer",
                            color: "white",
                          }}

                          // onClick={(e) =>
                          //   handleLogout(
                          //     e,
                          //     element.mainTextDesktop.toLocaleLowerCase()
                          //   )
                          // }
                        >
                          <a onClick={(e) => handleLogout(e, "logout")}>
                            Logout
                          </a>
                        </li>
                      ) : (
                        <li
                          className="main"
                          style={{
                            // First item of this list owns the margin-left:auto
                            // that pushes the cluster right. Only the first —
                            // two autos in one flex row split the free space.
                            marginLeft: i === 0 ? "auto" : "",
                            display: "flex",
                          }}
                          // onMouseEnter={
                          //   isAuthenticated
                          //     ? () => updateBackDropVisibility("enter")
                          //     : () => updateBackDropVisibility("leave")
                          // }
                          // onMouseLeave={() => updateBackDropVisibility("leave")}
                        >
                          {!isMobile && isAuthenticated && !loading && (
                            <div
                              style={{
                                marginBottom: "-23px",
                                zIndex: "10000000",

                                // transform: "translateY(10px)",
                              }}
                            >
                              <div
                                style={{
                                  width: isCaptain ? "60px" : "50px",
                                  height: isCaptain ? "70px" : "60px",
                                  // backgroundImage: `url(${
                                  //   isCaptain ? frame : beeframe
                                  // })`,
                                  transform: !isCaptain ? "rotate(-30deg)" : "",
                                  // backgroundImage: `url(${frame})`,
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "center",
                                  position: "relative",
                                  cursor: "pointer",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  alignSelf: "center",
                                  // border:"none"
                                }}
                              >
                                <div
                                  style={{
                                    width: isCaptain ? "60px" : "50px",
                                    height: isCaptain ? "70px" : "60px",
                                    position: "absolute",
                                    zIndex: "1",
                                  }}
                                >
                                  <img
                                    src={isCaptain === true ? frame : beeframe}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                    }}
                                  />
                                </div>

                                {!profileLoading && (
                                  <div
                                    className={
                                      isCaptain ? "bee-hexagon" : "elipse-img"
                                    }
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      marginBottom: `${
                                        isCaptain === true ? 0 : "7px"
                                      }`,
                                    }}
                                  >
                                    <img
                                      alt=""
                                      src={userProfile ? userProfile : dummy}
                                      width={"63px"}
                                      height={"66px"}
                                      style={{
                                        border: "none",
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          <Link
                            to={element.href}
                            className={`desktop-item ${
                              element.active ? "link_active" : ""
                            }`}
                          >
                            {isAuthenticated
                              ? userEmail
                              : element.mainTextDesktop}
                          </Link>
                          <input type="checkbox" id={element.mainTextDesktop} />

                          <a href={element.href} className="mobile-item">
                            {isAuthenticated
                              ? userEmail
                              : element.mainTextDesktop}
                          </a>

                          {element.hasMegaDrop ? (
                            <div
                              className="mega-box"
                              style={{
                                background: theme === "light" ? "#FAFAFC" : "",
                                color:
                                  theme === "light" ? "#333336 !important" : "",
                              }}
                              ref={elementRef}
                            >
                              <div className="content">
                                {element.dropDownContent.map((elem: any) => (
                                  <div
                                    className="row"
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <header
                                      style={{
                                        color:
                                          theme === "light"
                                            ? "#A0A0A5 !important"
                                            : "",
                                      }}
                                    >
                                      {elem?.heading}
                                    </header>
                                    <ul
                                      className={`mega-links ${
                                        elem?.mainList ? "main" : ""
                                      }`}
                                    >
                                      {elem?.links.map((el: any) => (
                                        <li className="profile-list-item">
                                          <a
                                            onClick={(e) =>
                                              handleLogout(
                                                e,
                                                el.name.toLocaleLowerCase()
                                              )
                                            }
                                            href={el.href}
                                            className={
                                              theme === "light"
                                                ? "dark_color"
                                                : ""
                                            }
                                          >
                                            {el.name}
                                          </a>
                                          <div
                                            className={`profile-inner-item-border-bottom `}
                                            style={{
                                              background: "#11BE6A",
                                              width: "16px",
                                              height: "3px",
                                              marginTop: "-5px",
                                            }}
                                          ></div>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                ))}

                                <div className="row"></div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </li>
                      )}
                    </>
                  ))}
            </ul>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* Zodiac sits at the top RIGHT, immediately left of the theme
                switcher (Brian's call). xTokens is a section of indexx.ai
                rather than a separate site, so the current product is derived
                from the route. */}
            <span style={{ display: "flex", alignItems: "center", marginRight: 14 }}>
              <ZodiacLauncher
                productId={
                  typeof window !== "undefined" &&
                  window.location.pathname.toLowerCase().startsWith("/xtokens")
                    ? "xtokens"
                    : undefined
                }
                /* Always dark, regardless of the site's light/dark toggle. That
                   toggle themes the PAGE; this nav has no light variant in
                   Header_test/style.css and stays dark in both modes. */
                tone="dark"
                /*
                 * No reloadOnSession:false here, deliberately.
                 *
                 * This bar now re-renders on "zodiac:session", but it is not
                 * the only thing on these routes that reads the session while
                 * mounting: around thirty components under it still decide
                 * with `localStorage.getItem("access_token")` once and never
                 * look again. Dropping the reload would leave the header right
                 * and the page behind it empty. LandingHeader can opt out
                 * because the redesigned routes have no such readers; turning
                 * it off here is a per-page migration, not a flag flip.
                 */
                auth={{ clientId: "indexx-web" }}
              />
            </span>
            <DarkMode />
            <label htmlFor="menu-btn" className="btn menu-btn">
              <CrossIcon />
            </label>
          </div>
        </div>
      </nav>
    </>
  );
};

export default HeaderTest;
